import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';

const EASE = [0.22, 1, 0.36, 1];

/**
 * Reveal-on-scroll wrapper. Fades and lifts its children the first time they
 * enter the viewport. Renders a plain element when the visitor prefers
 * reduced motion so nothing is hidden behind an animation.
 */
const Reveal = ({
  children,
  as = 'div',
  delay = 0,
  y = 28,
  once = true,
  className,
  ...rest
}) => {
  const reduceMotion = useReducedMotion();
  const Component = motion[as] || motion.div;

  if (reduceMotion) {
    return (
      <Component className={className} {...rest}>
        {children}
      </Component>
    );
  }

  return (
    <Component
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once, margin: '0px 0px -12% 0px' }}
      transition={{ duration: 0.7, delay, ease: EASE }}
      {...rest}
    >
      {children}
    </Component>
  );
};

export default Reveal;
